import React from 'react';
import { ThemeProvider, createTheme, responsiveFontSizes } from '@mui/material/styles';
import { Provider } from 'react-redux';
import CssBaseline from '@mui/material/CssBaseline';
import { Amplify } from 'aws-amplify';
import { fetchAuthSession } from 'aws-amplify/auth';

import AppRouter from './routes/AppRouter/AppRouter';
import { authConfig } from './aws-config';
import store from './redux/store';
import { Colors, FontWeight } from './assets/styles';
import { Snackbar } from './components';
import useStyles from './App.styles';


// @ts-ignore: suppress TS2345 type mismatch
Amplify.configure(authConfig);

let theme = createTheme({
  palette: {
    action: {
      disabled: Colors.Gray2,
    },
    primary: {
      main: Colors.Blue1,
      dark: Colors.Blue,
    },
    secondary: {
      main: Colors.Orange2,
    },
  },
  typography: {
    fontFamily: ['Museo Sans', 'sans-serif'].join(','),
    fontWeightLight: FontWeight.Light,
    fontWeightRegular: FontWeight.Regular,
    fontWeightBold: FontWeight.Bold,
    h1: {
      fontSize: 28,
      color: Colors.Blue,
      fontWeight: FontWeight.Bold,
    },
    h2: {
      fontSize: 20,
      color: Colors.Blue1,
      fontWeight: FontWeight.Bold,
    },
    body1: {
      color: Colors.Gray,
      fontWeight: FontWeight.Regular,
    },
    body2: {
      fontSize: 16,
      color: Colors.Blue,
      fontWeight: FontWeight.Bold,
    },
  },
});

theme = responsiveFontSizes(theme);

const App = () => {
  useStyles();
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Provider store={store}>
        <Snackbar />
        <AppRouter />
      </Provider>
    </ThemeProvider>
  );
};

export default App;